import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <nav className={`fixed top-0 w-full z-50 border-b transition-all duration-300 ${scrolled ? 'bg-[#040a14]/70 backdrop-blur-2xl border-white/[0.06]' : 'bg-transparent border-transparent'}`}>
        <div className="mx-auto max-w-[1280px] px-6 lg:px-8 h-[72px] flex items-center justify-between">
          <div className="flex items-center gap-10">
            <a href="/" className="flex items-center gap-3 group">
              <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center shadow-[0_0_20px_rgba(14,165,233,0.45)] group-hover:shadow-[0_0_28px_rgba(14,165,233,0.55)] transition">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" className="text-white"><rect x="3" y="3" width="8" height="8" rx="2" fill="white" fillOpacity="0.95"/><rect x="13" y="3" width="8" height="8" rx="2" fill="white" fillOpacity="0.65"/><rect x="3" y="13" width="8" height="8" rx="2" fill="white" fillOpacity="0.65"/><rect x="13" y="13" width="8" height="8" rx="2" fill="white" fillOpacity="0.45"/></svg>
              </div>
              <span className="text-[20px] font-semibold tracking-tight text-white">draunt</span>
            </a>
            <div className="hidden lg:flex items-center gap-7 text-[13.5px] text-white/60">
              <a href="/#apps" className="hover:text-white transition">View Apps</a>
              <a href="/contact" className="hover:text-white transition">Contact Us</a>
            </div>
          </div>
          <div className="hidden lg:flex items-center gap-3">
            <a href="/contact" className="text-sm text-white/70 hover:text-white px-4 py-2 transition">Contact</a>
            <a href="/#apps" className="rounded-full bg-white text-black text-[13.5px] font-medium px-5 py-2.5 hover:bg-white/90 transition shadow-[0_8px_24px_rgba(255,255,255,0.15)]">Download</a>
          </div>
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden w-9 h-9 rounded-xl glass flex items-center justify-center text-white">
            <span className="text-lg">{mobileMenuOpen ? '✕' : '☰'}</span>
          </button>
        </div>
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="lg:hidden border-t border-white/10 bg-[#040a14]/80 backdrop-blur-xl overflow-hidden">
              <div className="px-6 py-6 space-y-1 text-sm">
                <a href="/#apps" onClick={() => setMobileMenuOpen(false)} className="block py-2 text-white/80 hover:text-white">View Apps</a>
                <a href="/contact" onClick={() => setMobileMenuOpen(false)} className="block py-2 text-white/80 hover:text-white">Contact Us</a>
                <div className="flex gap-3 pt-3">
                  <a href="/contact" className="flex-1 text-center rounded-full border border-white/15 py-3 text-white/80">Contact</a>
                  <a href="/#apps" className="flex-1 text-center rounded-full bg-white text-black py-3 font-medium">Download</a>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
      <div className="h-[72px]" />
    </>
  );
}
